import { Injectable } from '@angular/core';

import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';

import { Observable } from 'rxjs';
import { api } from "@bayclubs/utils"
import { camps } from '../../models/models.generated';

@Injectable()
export class PurchaseApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.CampPurchaseSearchRequest, showLoader: boolean = true): Observable<api.OperationPagedResult<camps.CampPurchaseInfo>> {
        return this.http.post<api.OperationPagedResult<camps.CampPurchaseInfo>>("purchase/search", request, showLoader);
    }

    public get(id: camps.Guid): Observable<api.OperationResultValue<camps.CampPurchaseDetails>> {
        return this.http.get<api.OperationResultValue<camps.CampPurchaseDetails>>(`purchase/${id}`, true);
    }

    public fullRefund(id: camps.Guid, reason: camps.SetRefundReasonRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResultValue<camps.CampPurchaseDetails>>(`purchase/${id}/fullRefund`,reason, true);
    }

    public initRefund(id: camps.Guid, reason: camps.SetRefundReasonRequest): Observable<api.OperationResultValue<camps.InitRefundResponse>> {
        return this.http.post<api.OperationResultValue<camps.InitRefundResponse>>(`purchase/${id}/initRefund`,reason, true);
    }
}
